module.exports = __webpack_public_path__ + "img/icon(2).7ce2003c.png";